import React, { useState } from "react";
import Button from "../button/button";
import NoImage from "../../assets/img/noimage.png";
import { useNavigate } from "react-router-dom";
import { FiAlertCircle, FiAlertTriangle } from "react-icons/fi";
import "./card.scss";
import Badge from "../badge/badge";

export default function Card({
    image,
    thumbnail,
    title,
    material,
    reference,
    codCategoria,
    pendienteAprobacion,
    link,
    showButton = true,
    dotacionesCount,
    comentarios, // Ahora es opcional
}) {
    const [imgSrc, setImgSrc] = useState(thumbnail || image || NoImage);
    const navigate = useNavigate();

    const handleImageError = () => {
        setImgSrc(NoImage);
    };

    const handleButtonClick = () => {
        navigate(link);
    };

    // Verifica si hay comentarios para mostrar (no null/undefined y no string vacío)
    const hasComments = comentarios && comentarios.trim() !== "";

    return (
        <div className="card">
            {pendienteAprobacion && (
                <div className="card__pendiente-aprobacion">
                    <span className="card__pendiente-aprobacion__icon">
                        <FiAlertCircle />
                    </span>
                    <span className="card__pendiente-aprobacion__label">
                        Pendiente de aprobación
                    </span>
                </div>
            )}

            <div className="card__image">
                <img src={imgSrc} alt={title} onError={handleImageError} />
            </div>

            <div className="card__content">
                <h3 className="card__title" title={title}>
                    {title}
                </h3>
                {material && <p className="card__material">{material}</p>}
                {codCategoria && <p className="card__categoria">Imagen: {codCategoria}</p>}
                <span className="card__reference">Ref: {reference}</span>
            </div>

            {showButton && (
                <div className="card__button">
                    <Button
                        label="Ver detalles"
                        variant="filled"
                        fullWidth="width-100"
                        onClick={handleButtonClick}
                    />
                </div>
            )}

            {(dotacionesCount > 0 || hasComments) && (
                <div className="card__footer-info">
                    {dotacionesCount > 0 && (
                        <div className="card__dotaciones-container">
                            <span className="card__dotaciones-label">
                                Dotaciones fijas por tienda:
                            </span>
                            <Badge
                                label={dotacionesCount.toString()}
                                variant="warning"
                                className="dotaciones-badge"
                                size="S"
                            />
                        </div>
                    )}

                    {hasComments && (
                        <div className="card__comentario">
                            <span
                                className="card__comentario__title"
                                title={comentarios}
                            >
                                Comentario:{" "}
                                <span className="card__comentario__text">
                                    {comentarios}
                                </span>
                            </span>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
